import { render, staticRenderFns } from "./switchProfile.vue?vue&type=template&id=d2211b28&scoped=true&"
import script from "./switchProfile.vue?vue&type=script&lang=js&"
export * from "./switchProfile.vue?vue&type=script&lang=js&"
import style0 from "./switchProfile.vue?vue&type=style&index=0&id=d2211b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2211b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2211b28')) {
      api.createRecord('d2211b28', component.options)
    } else {
      api.reload('d2211b28', component.options)
    }
    module.hot.accept("./switchProfile.vue?vue&type=template&id=d2211b28&scoped=true&", function () {
      api.rerender('d2211b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/switchProfile/switchProfile.vue"
export default component.exports